<template>
  <div class="">
    <button class="g--button w-full" :disabled="disabled" @click="startCheckout()">Book this class</button>
  </div>

  <Teleport to="body">
    <div ref="modal">
      <div
          v-if="showPaymentForm"
          id="payment-form-wrapper"
          class="fixed z-30 h-full w-full bg-black/80 top-0 left-0 flex justify-center items-center">

        <div ref="innerModal" class="overflow-y-auto max-h-[100%] bg-white rounded-md p-4 w-full max-w-[450px] min-h-[250px]">
          <div class="g--label">Class</div>
          <session-redux :session="session" :voucher-price-friendly="voucherPriceFriendly"></session-redux>
          <div v-show="step == 1" class="mt-4">
            <div class="g--label">Email address</div>
            <div class="text-sm">{{ email }}</div>
            <div class="g--label mt-4">Terms & Conditions</div>
            <div class="flex mt-2">
              <input class="mr-2" type="checkbox" id="terms" v-model="acceptedTerms"/>
              <label for="terms" class="text-sm">I accept the <a href="/terms-conditions-participants" class="underline" target="_blank">terms & conditions</a> and <a target="_blank" class="underline" href="/privacy-policy">privacy policy</a>.</label>
            </div>
            <div class="flex mt-1">
              <input class="mr-2" type="checkbox" id="medical" v-model="acceptedMedical"/>
              <label for="medical" class="text-sm">I accept the <a class="underline" target="_blank" href="/disclaimer">disclaimer</a></label>
            </div>
            <button :disabled="!acceptedTerms || !acceptedMedical" class="g--button mt-4 w-full" @click="doStep2()">Next
            </button>
          </div>
          <div v-if="step == 2">
            <div class="g--label mt-4">Voucher</div>
            <button v-if="voucherApplied == false && showVoucherInput == false" @click.stop="showVoucherInput = true"
                    class="w-full text-left text-sm text-teal hover:underline">Use a voucher
            </button>
            <div v-if="showVoucherInput" class="mt-2 gap-2 flex items-center">
              <input v-model="voucher" class="w-full border border-gray-300 p-2 rounded-md"
                     placeholder="Enter voucher code">
              <button @click="applyVoucher()" class="g--button w-full">Apply</button>
            </div>
            <div v-if="showVoucherInput && errorVoucher">
              <div class="text-sm text-red mt-2">Invalid voucher code</div>
            </div>
            <div v-if="voucherApplied">
              <div class="text-sm text-green-800 mt-2">Voucher {{ voucher }} applied.</div>
            </div>

            <!--            <div class="g&#45;&#45;label mt-4">Payment method</div>-->
            <!--            <div class="mt-2 grid grid-rows-2 gap-2">-->
            <!--              <button @click="paymentMethod = 'card'; checkoutIntent()" class="g&#45;&#45;radio text-base"-->
            <!--                      :class="{'g&#45;&#45;radio&#45;&#45;selected': paymentMethod == 'card'}">Pay by card-->
            <!--              </button>-->
            <!--              <button @click="paymentMethod = 'package'" class="g&#45;&#45;radio text-base"-->
            <!--                      :class="{'g&#45;&#45;radio&#45;&#45;selected': paymentMethod == 'package'}">Use package-->
            <!--              </button>-->
            <!--            </div>-->
            <div v-if="paymentMethod == 'card'" class="g--label mt-4 mb-2">Payment</div>
            <div v-if="paymentMethod == 'card'">
              <div class="min-h-[205px] flex items-center justify-center">
                <div ref="spinner">
                  <Spinner></Spinner>
                </div>
                <form id="payment-form"
                      class="hidden w-full ">
                  <div id="link-authentication-element">
                    <!-- Link Authentication Element will be inserted here -->
                  </div>
                  <div id="payment-element" class="mt-4">
                    <!-- Elements will create form elements here -->
                  </div>
                  <button class="g--button mt-4" id="submit">Pay</button>
                  <div id="error-message" class="text-red-500 mt-2"></div>
                </form>
              </div>
            </div>
            <div v-if="paymentMethod == 'package'">
              <div v-for="packageItem in availablePackages" class="mt-2 ml-8">
                <button class="g--radio g--radio--green text-sm"
                        :class="{'g--radio--selected': paymentMethod == 'package'}">{{ packageItem.title }}
                  ({{ packageItem.remainingUses }} remaining)
                </button>
              </div>
            </div>
<!--            <div class="mt-2" v-else-if="paymentMethod == 'package'">-->
<!--              <button @click="bookWithPackage()" class="g&#45;&#45;button">Book now</button>-->
<!--            </div>-->
            <div class="mt-2" v-else-if="paymentMethod == 'voucher'">
              <button @click="bookWithVoucher()" class="g--button">
                <span v-if="bookingWithVoucher">Booking...</span>
                <span v-else>Book now</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>

import { nextTick, onMounted, ref } from 'vue';
import SessionRedux from './SessionRedux.vue';
import Spinner from './Spinner.vue';



const props = defineProps({
      // currency: String,
      // price: Number,
      // sessionId: Number,
      // studentId: Number,
      // name: String,
      // email: String
      session: Object,
      connectId: String,
      disabled: {
        type: Boolean,
        default: false
      }
    })
;

const email = ref('');
const name = ref('');
const studentId = ref(0);
const currency = ref('');

const acceptedTerms = ref(false);
const acceptedMedical = ref(false);

const step = ref(1);
const modal = ref(null);
const innerModal = ref(null);
const showPaymentForm = ref(false);

const paymentMethod = ref('card');

const showVoucherInput = ref(false);
const voucher = ref('');
const errorVoucher = ref(false);
const voucherApplied = ref(false);
const voucherPriceFriendly = ref('');
// const bookingWithoutPayment = ref(false);

const availablePackages = ref([]);

const spinner = ref(null);

const bookingWithVoucher = ref(false);

onMounted(() => {
// close if click outside #payment-form-wrapper
  loadUserInfo();
  actionOutsideClick();
  // loadPackages();
});

const loadUserInfo = () => {
  fetch('/actions/live-yoga-teachers/checkout/get-user-info', {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
  }).then((response) =>
      response.json().then((json) => {
        console.log(json);
        if (json.user) {
          email.value = json.email;
          name.value = json.name;
          studentId.value = json.studentId;
          currency.value = json.currency;
        } else {
          // alert('hey');
        }
      })
  );
}


const loadPackages = () => {
  fetch('/actions/live-yoga-teachers/checkout/load-user-packages', {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
  }).then((response) =>
      response.json().then((json) => {
        console.log(json);
        availablePackages.value = json;
      })
  );
}


const startCheckout = () => {
  // paymentFormWrapper.value.classList.remove('hidden');
  showPaymentForm.value = true;
}

const actionOutsideClick = () => {
  modal.value.addEventListener('click', function(event) {
    console.log(event.target);
    console.log(innerModal.value.contains(event.target));
    if (!innerModal.value.contains(event.target)) {
      // document.querySelector('#payment-form-wrapper').classList.add('hidden');
      showPaymentForm.value = false;
      step.value = 1;
    }
  });
}


const doStep2 = () => {
  if (acceptedTerms.value && acceptedMedical.value) {
    step.value = 2;
    console.log('in step 2');
    // const result =  checkoutIntent();
    checkoutIntent();

  }
}

const applyVoucher = () => {
  console.log('applying voucher');
  console.log(voucher.value);
  errorVoucher.value = false;
  fetch('/actions/live-yoga-teachers/checkout/apply-voucher?sessionId=' + props.session.id + '&voucher=' + voucher.value, {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
  }).then((response) =>
      response.json().then((json) => {
        console.log(json);
        if (!json.valid) {
          errorVoucher.value = true;
        } else {
          if (json.fullDiscount) {
            voucherApplied.value = true;
            showVoucherInput.value = false;
            voucherPriceFriendly.value = json.voucherPriceFriendly;
            paymentMethod.value = 'voucher';
          } else {
            voucherApplied.value = true;
            showVoucherInput.value = false;
            voucherPriceFriendly.value = json.voucherPriceFriendly;
            checkoutIntent();
          }
        }
      })
  );
}

const bookWithVoucher = () => {
  if (bookingWithVoucher.value) {
    return;
  }
  bookingWithVoucher.value = true;
  let data = {};
  data[csrfTokenName] = csrfTokenValue;

  fetch('/actions/live-yoga-teachers/checkout/book-with-voucher?sessionId=' + props.session.id + '&voucher=' + voucher.value, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(data),
  }).then((response) =>
      response.json().then((json) => {
        if (json.booked) {
          window.location.href = '/bookings/confirmation?bookingRef=' + json.bookingRef;
        } else {
          bookingWithVoucher.value = false;
        }
      }))
}

const checkoutIntent = () => {
  console.log('doing checkout intent');
  let data = {};
  data[csrfTokenName] = csrfTokenValue;

  fetch('/actions/live-yoga-teachers/checkout/intent?sessionId=' + props.session.id + '&voucher=' + voucher.value, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(data),
  }).then((response) =>
          response.json().then((json) => {
            console.log(json.clientSecret);

            const stripe = Stripe(
                // 'pk_test_51Hf3whA9djpx0tsZwIc9BSTvenACfV7sAiZqinCvpSqZuliOJmO8tllMA3sFZeyHXT1kZFpGXLFS22A8CmxkKAsT00szimVi0m',
                'pk_live_51Hf3whA9djpx0tsZAM2JhnjimyGSwOg3SCoK9gVadmJPZahQpQU9a5vHUfGf8ZzzqaxxxZpanHyTIq17KyJvbocX00ll8Shoj0',
                {
                  stripeAccount: json.connectId,
                }
            );


            const options = {
              clientSecret: json.clientSecret,
              // Fully customizable with the Appearance API
              appearance: {/*...*/},
              business: "Live Yoga Teachers",
            };
// Set up Stripe.js and Elements to use in checkout form using the client secret
            const elements = stripe.elements(options);

            // Create and mount the Link Authentication Element
            const linkAuthenticationElement = elements.create("linkAuthentication", {
              defaultValues: {
                email: email.value,
              }
            });
            linkAuthenticationElement.mount("#link-authentication-element");

// Create and mount the Payment Element
            const paymentElement = elements.create("payment", {
              layout: {
                type: 'tabs',
                defaultCollapsed: true,
              },
              fields: {
                billingDetails: {
                  name: 'auto',
                  email: 'never',
                  address: 'if_required'
                }
              },
              wallets: {
                applePay: 'auto',
                googlePay: 'auto'
              }
            });
            paymentElement.mount("#payment-element");
            paymentElement.on('ready', () => {

              const form = document.getElementById('payment-form');
              form.classList.remove('hidden');
              spinner.value.classList.add('hidden');

              form.addEventListener('submit', async (event) => {
                event.preventDefault();

                const {error} = await stripe.confirmPayment({
                  //`Elements` instance that was used to create the Payment Element
                  elements,
                  confirmParams: {
                    return_url: 'https://liveyogateachers.com/bookings/confirmation',
                    payment_method_data: {
                      billing_details: {
                        name: name.value,
                        email: email.value,
                      }
                    },
                  },
                });

                if (error) {
                  // This point will only be reached if there is an immediate error when
                  // confirming the payment. Show error to your customer (for example, payment
                  // details incomplete)
                  const messageContainer = document.querySelector('#error-message');
                  messageContainer.textContent = error.message;
                } else {
                  // Your customer will be redirected to your `return_url`. For some payment
                  // methods like iDEAL, your customer will be redirected to an intermediate
                  // site first to authorize the payment, then redirected to the `return_url`.
                }
              });
            });

          })
  );


}


</script>
